import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getProductBrandUrl } from "../../../util";
import { selectProductDetails } from "../selectors";
import { useRouteSlug } from "@/hooks";
import { Product } from "../../../services/productService/types";
import "./style.scss";

const BrandDetails = () => {
  const item = useSelector(selectProductDetails);
  const routeSlug = useRouteSlug();
  const brand = item.brand?.label;
  const title = item.title?.label;

  const getBrandProductLink = (item: Product): string => {
    const brandUrl = item && getProductBrandUrl(item);
    return brandUrl ? `/${routeSlug}${brandUrl}` : "";
  };

  const BrandLinkTag = props => {
    const brandLink = getBrandProductLink(item);
    return brandLink ? (
      <Link to={brandLink} {...props} />
    ) : (
      <Fragment {...props} />
    );
  };

  return (
    <div className="brand_detail_wrapper">
      {brand && (
        <BrandLinkTag>
          <h5 className="pdp_brand">{brand}</h5>
        </BrandLinkTag>
      )}
      {title && <h1>{title}</h1>}
    </div>
  );
};

export default BrandDetails;
